import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { Section } from "@react-email/components";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { useTopBlockStyles } from "../../../Design/useTopBlockStyles";
import { defaultStyles } from "./defaultStyles";

export interface DefaultBlockProps extends ComponentPropsWithRef<"table"> {
  content?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const DefaultBlock = forwardRef<HTMLTableElement, DefaultBlockProps>(
  ({ content, styles, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles,
        ignoreDefaults: false,
      },
    );

    return (
      <Section
        ref={ref}
        style={{
          ...backgroundStyles,
          ...paddingStyles,
          ...marginStyles,
        }}
        {...rest}
      >
        {content}
      </Section>
    );
  },
);

DefaultBlock.displayName = "DefaultBlock";
